import React, { Fragment } from "react";
import Input from "antd/es/input/Input";

export default function Blank(props) {
  const {
    onSetPinyin,
    onSetHanzi,
    pinyin,
    hanzi,
  } = props;

  return (
    <Fragment>
      <Input
        onChange={onSetPinyin}
        value={pinyin}
        placeholder="拼音"
        style={{ minWidth: '15vw'}}
      />
      <Input
        onChange={onSetHanzi}
        value={hanzi}
        placeholder="汉子"
        style={{ minWidth: '15vw'}}
      />
    </Fragment>
  )
}
